/*
 * types/services/dr2am.tasks.roles.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceDeleteRoleResponse model module.
 * @module model/ServiceDeleteRoleResponse
 * @version version not set
 */
export class ServiceDeleteRoleResponse {
  /**
   * Constructs a new <code>ServiceDeleteRoleResponse</code>.
   * @alias module:model/ServiceDeleteRoleResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceDeleteRoleResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceDeleteRoleResponse} obj Optional instance to populate.
   * @return {module:model/ServiceDeleteRoleResponse} The populated <code>ServiceDeleteRoleResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceDeleteRoleResponse();
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbResponseState} state
 */
ServiceDeleteRoleResponse.prototype.state = undefined;


